import { CloudOutlined, PhoneOutlined, UserOutlined } from "@ant-design/icons";
import { Row } from "antd";

import { viewTypes } from "@evolved/constants";

import { InfoCard } from "components/info-card";
import { SetUsers } from "./modals/set-users";
import { UserDefinedFields } from "components/user-defined-fields";
import { renderList } from "utils/render-list";
import { useModal } from "hooks/use-modal";
import { useUsers } from "data/use-users";
import { ScrollableContent } from "../../components/scrollable-content";

export const Details = (props) => {
  const { organization, vendor } = props;

  const { modal: usersModal, open: openUsersModal } = useModal(SetUsers);

  const users = useUsers();

  return (
    <>
      {usersModal}
      <ScrollableContent>
        <Row gutter={16} type="flex">
          <InfoCard
            content={vendor.phone || "--"}
            Icon={PhoneOutlined}
            label="Phone"
          />
          <InfoCard content={vendor.address || "--"} label="Address" />
          <InfoCard
            content={vendor.website || "--"}
            Icon={CloudOutlined}
            label="Website"
          />
          <UserDefinedFields
            data={vendor}
            organization={organization}
            type={viewTypes.VENDOR}
          />
          <InfoCard
            content={renderList(users.byIds(vendor.users), "Assign sales reps")}
            Icon={UserOutlined}
            label="Sales Reps"
            onClick={() => openUsersModal({ vendor })}
          />
        </Row>
      </ScrollableContent>
    </>
  );
};
